import React, { useEffect, Suspense } from 'react';
import { Container, Row } from 'reactstrap';
import './Newsroom.css';

const Newsroom = () => {
  const AllPost = React.lazy(() => import('../post/AllPost'));

  useEffect(() => {
    // Memastikan halaman tidak dimuat dalam iframe
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  class ErrorBoundary extends React.Component {
    constructor(props) {
      super(props);
      this.state = { hasError: false };
    }
  
    static getDerivedStateFromError(error) {
      return { hasError: true };
    }
  
    componentDidCatch(error, errorInfo) {
      console.error("Error caught by ErrorBoundary:", error, errorInfo);
    }
  
    render() {
      if (this.state.hasError) {
        return <div>Something went wrong. Please try again later.</div>;
      }
  
      return this.props.children;
    }
  }

  return (
    <div className="newsroom-container">
      {/* Header Section */}
      <header className="header-section">
        <div className="header-content">
          <h2>NEWSROOM</h2>
          <hr className="header-line" />
        </div>
      </header>

      <Container className="mt-5">
        <Row>
        <Suspense fallback={<div>Loading...</div>}>
          <ErrorBoundary>
            <AllPost />
          </ErrorBoundary>
        </Suspense>
        </Row>
      </Container>
    </div>
  );
};

export default Newsroom;